import { CashAccounting } from "../../CashAccounting/CashAccounting"
import CashRegisterController from "../../../../APIController/CashRegisterController"
import Text from "../../../../Components/Text"
import { useState } from "react"

const toDateInputValue = (date) => date.toISOString().split("T")[0]

export const CashRegisterEntryManagement = () => {
    const today = toDateInputValue(new Date())
    const [startDate, setStartDate] = useState(today)
    const [endDate, setEndDate] = useState(today)
    const { getStatisticsEntries } = CashRegisterController()

    const fetchData = async () => {
        if (!startDate || !endDate) return []
        const endOfDay = new Date(endDate)
        endOfDay.setDate(endOfDay.getDate() + 1)
        endOfDay.setHours(0, 0, 0, 0)
        return await getStatisticsEntries(new Date(startDate), endOfDay)
    }

    return (
        <div className="w-full h-full flex flex-col min-h-0 overflow-hidden">
            <Text type="maintitle" classNames="w-full flex shrink-0">Kassenabrechnung korrigieren</Text>
            <div className="flex gap-3 p-3 h-min w-full shrink-0">
                <div className="flex flex-col">
                    <label className="text-sm text-gray-600">Von</label>
                    <input
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        className="border rounded px-2 py-1"
                    />
                </div>
                <div className="flex flex-col">
                    <label className="text-sm text-gray-600">Bis</label>
                    <input
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        className="border rounded px-2 py-1"
                    />
                </div>
            </div>
            <div className="flex-1 min-h-0 overflow-hidden flex">
                <CashAccounting title="" bg="bg-white" alternateAction={fetchData} />
            </div>
        </div>
    )
}